import React from 'react'
import ExploreProductColumn from './ExploreProductColumn'
import closeIcon from '../../assets/SVG-Global_Homepage_ProductHome_PLP_FreeTrial/Icon - X - Black.svg'

class ExploreProducts extends React.Component{
    constructor(props){
        super(props);
        this.state={
            showContent: false,
            hovered: false,
            exploreProductColumn: []
        }
    }
    chunkArray(myArray, chunk_size){
        var results = [];
        if (myArray.length === 5) {
            results.push(myArray.splice(0, chunk_size));
        }
        if (myArray.length === 3) {
            results.push(myArray.splice(0, 3));
        }
        return results;
    }
    componentDidMount(){
        let result=this.chunkArray(this.props.exploreProductsData.menu_block, 2)
        this.setState({
            exploreProductColumn: result,
            showContent: true
        })
    }
    toggleHover = () => {
        this.setState(prevState => ({
            hovered: !prevState.hovered
        }))
    }
    render(){
        return(
            <React.Fragment>
               {this.state.showContent?
                <div className="collapse collapse-container" id="exploreProducts">
                    <div className="card desktop-collapse">
                        <div className="container">
                            <div className="row">
                                <div className="col collapse-heading">
                                    <div dangerouslySetInnerHTML={{ __html: this.props.exploreProductsData.hero_text_block}}>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                {this.state.exploreProductColumn.map((exploreProductColContent, index)=>{
                                    return <ExploreProductColumn 
                                    exploreProductColData={exploreProductColContent} key={index}/>
                                })}
                            </div>
                            <div className="row explore-close-button">
                                <div className="col-12 justify-self-center">
                                    <a data-toggle="collapse" data-target="#exploreProducts"
                                    className={`${this.state.hovered?"close-btn-hovered":""}`}
                                    onClick={this.props.toggleArrowHandler}
                                    onMouseEnter={this.toggleHover}
                                    onMouseLeave={this.toggleHover}>
                                        <img src={closeIcon} alt="close" height="14px" width="14px"/>
                                        <span className="close-btn">CLOSE</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               :null}
        </React.Fragment>
        )
    }
}
export default ExploreProducts